<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
      <div v-if="requestSave">
        <h1>Заявка успешно сохранена,<br/> можете закрыть эту вкладку</h1>
      </div>
      <div v-else>
        <div v-if="readyToWork">
          <div class="fl frstShortSeconLong" id="headOutgoing">
            <div>
              <div class="input_box">
                <label class="left">Тип продукта</label>
                <select v-model="productId">
                  <option :value="option.ProductType" v-for="option in getProduct">{{option.DlProductTypeName}}</option>
                </select>
              </div>
              <div class="input_box">
                <label class="left">Сумма займа</label>
                <select v-model="requestSum">
                  <option :value="Amount" v-for="Amount in getAvailableSum">{{Amount}}</option>
                </select>
              </div>
              <div class="input_box" v-show="getAvailablePeriod.length > 1">
                <label class="left">Срок займа {{getSelectedPskInfo.calcWeekTitle}}</label>
                <select v-model="CALC_WEEK">
                  <option :value="Period" v-for="Period in getAvailablePeriod">{{Period}}</option>
                </select>
              </div>
            </div>
            <div>
            </div>
          </div>
          <productInfo></productInfo>
          <formRequest v-on:loadNewLead="loadNewLead"></formRequest>
        </div>
        <div class="loaderWrap" v-else>
          <loader></loader>
        </div>
      </div>
    </div>
    <div class="borderBox" id="operatorScript">
      <OperatorScriptLayout :type="'income'" :parentID="'0'"></OperatorScriptLayout>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  import DataForInput from '@/gavnoCode/longFormOptions';
//для открытия данной странички по ссылки из х chrome://flags/#enable-desktop-pwas включить
  //#enable-desktop-pwas
  //#enable-desktop-pwas-link-capturing
  export default {
    name: "ClientService",
    components: {
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
      loader: () => import('@/components/loader'),
      formRequest: () => import('@/components/forms/formRequest'),
      formInput: () => import('@/components/forms/formInput'),
      formSelect: () => import('@/components/forms/formSelect'),
      productInfo: () => import('@/components/productInfo'),
    },
    data: function () {
      return {
        requestField: {},
        readyToWork: false,
        requestSave:false
      }
    },
    methods: {
      loadNewLead: function () {
        this.requestSave = true;
        this.$store.dispatch('resetToDefault');
      },
      loadOperatorScript: function () {
        if (this.getIncomeScripts.length == 0) {
          this.$myApi.scriptContent()
          .then((result) => {
            this.$store.dispatch('setScripts', result)
          })
          .catch((msg) => {
            console.log(msg)
          });
        }
      },
      getLeadByGuid:function(){
        this.$myApi.SendRequest({action: 'Operator_Get_Ref_DealType'}, this, 'mountedPsk', false)
        .then((result) => {
          if (result.length > 0) {
            //если есть массив, значит пришли новые продукты, добавляем в фронт и сохроняем к нам в бд
            this.$store.dispatch('addPskTable', result);
            this.$myApi.saveDefaultDealType(result).then().catch(e => console.log(e));
          } else {
            this.$myApi.getDefaultDealType()
            .then((result) => {
              this.$store.dispatch('addPskTable', result);
              this.readyToWork = true;
            })
            .catch(e => console.log(e))
          }
        }).catch(e => {
          console.log(e);
          alert('Ошибка :' + e);
        });
        // return false;
        try {
          let url_string = window.location.href;
          let url = new URL(url_string);
          let c = url.searchParams.get("guid");

          if (c.length > 0) {
            this.$myApi.SendRequest({action:'Operator_getLeadByGuid',guid:c}, this, 'getLeadByGuid', false)
            .then((response)=>{
              response[0]['REFFER'] = 'Клиентский сервис';
              response[0]['WHERE_TO_FIND_US'] = 'Клиентский сервис';
              this.$store.dispatch('setRequestField', {
                form: 'request',
                values: response[0]
              }).then(res => {
                this.$store.dispatch('saveSendData', {
                  target: 'CallStatus',
                  form: 'status',
                  value: 'Оформлена заявка'
                });
                this.$store.dispatch('saveSendData', {
                  target: 'LeadGUID',
                  form: 'LeadInfo',
                  value: c
                });
              }).catch(res => console.log(res));
              this.readyToWork = true;
            })
            .catch((error)=>console.log(error));
          } else {
            this.$store.commit('setContent', 'не корректные данные от икс');
            this.$store.commit('showModal');
          }
        } catch (e) {
          this.$store.commit('setContent', 'нет данных от икс');
          this.$store.commit('showModal');
        }
      }
    },
    computed:{
      ...mapGetters(['getIncomeScripts', 'getProduct', 'getAvailableSum', 'getIncomeScripts', 'getAvailablePeriod', 'getSelectedPskInfo', 'getTargetFieldValue']),
      ...mapState({
        valueVuex: state => state.requestField['sendData'],
        leadGroupName: state => state.requestField['sendData']['LeadInfo']['LeadType']
      }),
      productId: {
        get() {
          return this.valueVuex['request']['PRODUCT_ID']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'PRODUCT_ID',
            form: 'request',
            value: value
          });
        }
      },
      requestSum: {
        get() {
          return this.valueVuex['request']['CALC_SUMM']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'CALC_SUMM',
            form: 'request',
            value: value
          });
        }
      },
      CALC_WEEK: {
        get() {
          return this.valueVuex['request']['CALC_WEEK']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'CALC_WEEK',
            form: 'request',
            value: value
          });
        }
      }
    },
    mounted: function () {
      this.loadOperatorScript();
      this.getLeadByGuid();
    },
    watch: {}
  }
</script>

<style scoped>
  #headOutgoing{align-items: center;text-align: left;padding: 0 0 20px;}
  #headOutgoing p {margin: 0;padding: 0;}
  #pageContent{display: flex;align-items: flex-start;justify-content: flex-start;width: 100%;}
  #formArea{width: 900px;}
  @media screen and (max-width: 1600px){
    #pageContent{position: absolute;height: auto;}
  }
  .loaderWrap{min-height: 66vh;height: 1px;}
  #operatorScript{    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;}
</style>
